import Logo from "../../assets/images/touramp.png";
import Shop from "../../assets/icons/shop-landing.svg";
import Cart from "../../assets/icons/cart.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Down } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as Menu } from "../../assets/icons/menu.svg";
import Button from "../../components/ui/button";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../..";
import { setLanding } from "../../features/landing/reducer";
import SideNavigation from "./SideNavigation";
import { vendorAppUrl } from "../../utils/apiServices/baseUrl";

const LandingHeader = () => {
  const landing = useSelector((state: IRootState) => state.landing.value.type);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navLinks = [
    {
      to: "/about",
      text: "About Us",
    },
    {
      to: "/faq",
      text: "FAQs",
    },
    {
      to: "/contact",
      text: "Contact",
    },
  ];

  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const type = ["customers", "riders", "establishment"];

  const [user, setUser] = useState(landing);
  const data = type.filter((it) => it !== user);
  const onSetUser = (e: any) => {
    // navigate("/");
    const input = e;
    dispatch(
      setLanding({
        type: input,
      })
    );
    setUser(input);
    if (e === "customers") {
      navigate(`/`);
    } else {
      navigate(`/${e}`);
    }
  };
  return (
    <div>
      {isActive && <SideNavigation onClose={() => setIsActive(false)} />}
      <div className="sub flex gap-4 md:flex-row fixed top-0 text-black justify-between items-center py-3 px-4 md:px-11 lg:px-11 w-full z-[10] bg-white">
        <div className="">
          <Link to="/">
            <img src={Logo} className="w-28" alt="" />
          </Link>
        </div>
        <div className=" hidden sub md:flex items-center gap-10">
          {navLinks.map((item) => (
            <Link to={item.to} className="text-base font-normal" key={item.to}>
              {item.text}
            </Link>
          ))}
        </div>
        <div className="flex gap-4 items-center md:hidden">
          {landing === "customers" ? (
            <a href="/home" target="_blank">
              <img src={Cart} alt="" />
            </a>
          ) : landing === "establishment" ? (
            <a
              href={`${vendorAppUrl}/signup`}
              target="_blank"
              rel="noreferrer"
              className=" rounded-[3px] h-11 text-xs font-medium cursor-pointer py-4 px-8 bg-primary text-white"
            >
              Sign Up
            </a>
          ) : (
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="  rounded-[3px] h-11 text-xs font-medium cursor-pointer py-4 px-8 bg-primary text-white"
            >
              Sign Up
            </a>
          )}

          <Menu onClick={() => setIsActive(true)} />
        </div>
        <div className="hidden md:flex items-center gap-6">
          <div
            className="relative text-primary capitalize"
            onClick={() => setShow(!show)}
          >
            <div className="flex items-center gap-4 cursor-pointer">
              {user} <Down />
            </div>
            {show && (
              <div
                className="absolute flex flex-col items-end right-0 top-7"
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
              >
                {data.map((item) => (
                  <div
                    className="cursor-pointer shadow-md p-2 px-5 mt-2 rounded-xl w-fit bg-white"
                    key={item}
                    onClick={() => onSetUser(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          {landing === "customers" ? (
            <Button
              label="Shop Now"
              loading={false}
              onClick={() => navigate("/home")}
              color="orange"
              icon={Shop}
              hasIcon
              full
            />
          ) : landing === "establishment" ? (
            <a
              href={`${vendorAppUrl}/signup`}
              target="_blank"
              rel="noreferrer"
              className=" rounded-[3px] h-11 text-xs font-medium cursor-pointer py-4 px-8 bg-primary text-white"
            >
              Sign Up
            </a>
          ) : (
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="  rounded-[3px] h-11 text-xs font-medium cursor-pointer py-4 px-8 bg-primary text-white"
            >
              Sign Up
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingHeader;
